export default "__VITE_ASSET__5aed718f__"